import request from '@/utils/request'

// Warehousing By Period
export function epms5050List(param) {
    let data = param
    return request({
        url: `/delivery/epms5050/epms5050List`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}